import IndeterminateCheckbox from "./IndeterminateCheckbox";

export default IndeterminateCheckbox;
